import { useTranslate } from '@tolgee/react';
import { Select, SelectProps, Space } from 'antd';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { memo, useMemo } from 'react';

export interface CurrencySelectProps extends Omit<SelectProps, 'children' | 'options'> {
  dataSource: General.Currency[];
}

const CurrencySelect = (props: CurrencySelectProps) => {
  const lng = useSystemLanguageValue();
  const { dataSource, ...otherProps } = props;
  const { t } = useTranslate();

  return (
    <Select
      dropdownMatchSelectWidth={false}
      {...otherProps}
      options={useMemo(
        () =>
          dataSource.map((value) => {
            return {
              key: value,
              value,
              label:
                lng === 'zh-CN' ? (
                  <Space>
                    {t(`currency.${value}`)}
                    <span>{value}</span>
                  </Space>
                ) : (
                  value
                ),
            };
          }),
        [lng, dataSource, t],
      )}
    />
  );
};

export default memo(CurrencySelect);
